import React, { useEffect, useState } from 'react';
import { Grid, Typography, IconButton, Menu, ListItemIcon } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Item from '../Common/Item';
import {
  FolderWithActivity,
  closeDeleteFolderModalOnSuccess,
  deleteFolder,
  saveFolder,
} from '../../redux/activityLibrary/activityLibrarySlice';
import { displaySentence } from './Folder';
import StyledMenuItem from '../Common/StyledMenuItem';
import CustomModal from '../Common/CustomModal';
import DeleteActivityModal from './DeleteActivity';
import { useAppSelector } from '../../redux/hooks';

function Trash({ folder }: { folder: FolderWithActivity }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isEmptyTrashModalOpen, setIsEmptyTrashModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const coachId = useAppSelector((state) => state.coach.coach?.id);
  const emptyTrashLoading = useAppSelector((state) => state.activityLibrary.deleteFolderLoading);
  const emptyTrashSuccess = useAppSelector((state) => state.activityLibrary.isDeleteFolderSuccess);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseModal = () => {
    setIsEmptyTrashModalOpen(false);
  };

  const handleDelete = () => {
    if (coachId) dispatch(deleteFolder({ folderId: folder.id, coachId, isEmptyTrash: true }));
  };

  useEffect(() => {
    if (emptyTrashSuccess) {
      handleCloseModal();
      dispatch(closeDeleteFolderModalOnSuccess());
    }
  }, [emptyTrashSuccess]);

  const handleClick = (event: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
    if (
      event.target instanceof HTMLElement &&
      (event.target.tagName === 'DIV' ||
        event.target.tagName === 'IMG' ||
        event.target.tagName === 'SPAN')
    ) {
      dispatch(saveFolder(folder));
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  return (
    <Grid item xs={4}>
      <Item onClick={handleClick} sx={{ cursor: 'pointer' }}>
        <Grid display="flex" alignItems="center" gap="10px">
          <img src="/assets/icons/trash-bin-large.svg" alt="document" width={32} height={32} />
          <Typography variant="bodyBold" color="primary">
            {folder.name ? displaySentence(folder.name) : t('activityLibrary.filled.trash')}
          </Typography>
        </Grid>
        <IconButton>
          <MoreVertIcon style={{ color: '#7CAEBE' }} />
        </IconButton>
      </Item>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <StyledMenuItem
          onClick={() => {
            handleClose();
            setIsEmptyTrashModalOpen(true);
          }}
        >
          <ListItemIcon>
            <img src="/assets/icons/trash-bin-red.svg" alt="edit-pen" />
          </ListItemIcon>
          <Typography variant="bodyRegular" color="primary">
            {t('activityLibrary.filled.emptyTrash')}
          </Typography>
        </StyledMenuItem>
      </Menu>
      {isEmptyTrashModalOpen && (
        <CustomModal isOpen={isEmptyTrashModalOpen} xs={3.3}>
          <DeleteActivityModal
            handleDelete={handleDelete}
            handleDismiss={handleCloseModal}
            isAcitivtyLibraryTrashPath
            loading={emptyTrashLoading}
            loadingText={t('activityLibrary.filled.emptyingTrash')}
          />
        </CustomModal>
      )}
    </Grid>
  );
}

export default Trash;
